//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

      let previewSrc= require('@/assets/images/tj.png');
      import vFooter from '../../common/footer.vue'
      export default {
        name: 'app',
        data() {
            return {
              isIndex:0
            }
          },
          components: {
              vFooter
          },
          methods:{
              isShow(e){
                  let index = e,isIndex=this.isIndex
                  if(index==isIndex){
                    this.isIndex=0
                    return
                  }
                 this.isIndex=e
              },
              preview(e){
                   this._wxTool.setNoShare();
                  console.log(this.$url+previewSrc)
                  this._wxTool.previewImage(this.$url+previewSrc);
              }
          }
        }



// WEBPACK FOOTER //
// ./src/pages/my/direction/direction.vue